// Recently Viewed Products Utility

const RECENTLY_VIEWED_KEY = 'recentlyViewedProducts';
const MAX_RECENT_PRODUCTS = 15;

export const addToRecentlyViewed = (product) => {
  try {
    // Get current recently viewed products
    const recentlyViewed = getRecentlyViewed();
    
    // Create a clean product object with only necessary data
    const cleanProduct = {
      id: product.pr_id || product.id,
      name: product.name,
      slug: product.slug,
      price: product.pr_price || product.selectedPrice,
      salePrice: product.pr_sprice || product.selectedSprice,
      image: product.pr_image || product.images,
      ca_id: product.ca_id,
      shape: product.shape,
      viewedAt: new Date().toISOString()
    };
    
    // Remove if already exists (to avoid duplicates)
    const filteredProducts = recentlyViewed.filter(item => item.id !== cleanProduct.id);
    
    // Add to beginning of array
    filteredProducts.unshift(cleanProduct);
    
    // Keep only the most recent 15 items
    const limitedProducts = filteredProducts.slice(0, MAX_RECENT_PRODUCTS);
    
    // Save to localStorage
    localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(limitedProducts));
    
    return limitedProducts;
  } catch (error) {
    console.error('Error adding to recently viewed:', error);
    return [];
  }
};

export const getRecentlyViewed = () => {
  try {
    const stored = localStorage.getItem(RECENTLY_VIEWED_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch (error) {
    console.error('Error getting recently viewed products:', error);
    return [];
  }
};

export const clearRecentlyViewed = () => {
  try {
    localStorage.removeItem(RECENTLY_VIEWED_KEY);
  } catch (error) {
    console.error('Error clearing recently viewed products:', error);
  }
};

export const removeFromRecentlyViewed = (productId) => {
  try {
    const recentlyViewed = getRecentlyViewed();
    const filteredProducts = recentlyViewed.filter(item => item.id !== productId);
    localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(filteredProducts));
    return filteredProducts;
  } catch (error) {
    console.error('Error removing from recently viewed:', error);
    return getRecentlyViewed();
  }
};